import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import API from "@/service/index";
import { LoadingStatusType } from "../../enums/enums";

@Module({ namespaced: true })
export default class LineConnect extends VuexModule {
  public lineConnectLoadingStatus = LoadingStatusType.None;

  @Mutation
  public setLoading(logIn: any): void {
    this.lineConnectLoadingStatus = LoadingStatusType.Loading;
  }

  @Mutation
  public setLoadingSuccess(): void {
    this.lineConnectLoadingStatus = LoadingStatusType.Success;
  }

  @Mutation
  public setLoadingFail(): void {
    this.lineConnectLoadingStatus = LoadingStatusType.Fail;
  }

  @Action
  public LineConnect(_input: any): void {
    this.context.commit("setLoading");
    API.LineService.DoLineSetConnect(_input).then((res: any) => {
      if (res.data.resCode == "200") {
        this.context.commit("setLoadingSuccess");
      } else {
        this.context.commit("setLoadingFail");
      }
    });
  }

  get getLineConnectLoadingStatus(): LoadingStatusType {
    return this.lineConnectLoadingStatus;
  }
}
